import { addLocaleMessages } from '@/plugins/i18n';

addLocaleMessages(require.context('./i18n', true, /[A-Za-z0-9-_,\s]+\.json$/i));

export { $t, default } from '@/plugins/i18n';
